/**
 * @description Component-MobileHistoryCard
 */
import './index.less';

import { FC, ReactNode } from 'react';

interface IPropTypes {
  children: ReactNode;
  header?: ReactNode;
  className?: string;
  onClick?: () => void;
}

const MobileHistoryCard: FC<IPropTypes> = ({ children, header, className, onClick }) => {
  return (
    <div className={`syn-mobile-history-card ${className || ''}`} onClick={onClick}>
      {header && <div className="syn-mobile-history-card-row syn-mobile-history-card-header">{header}</div>}
      {children}
    </div>
  );
};

export default MobileHistoryCard;
